import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { IngresosActivosTab } from './ingresos-activos-tab';
import { HistorialCondominioTab } from './historial-condominio-tab';
import { VisitorPassesTab } from './visitor-passes-tab';
import { WalkInModal } from './walk-in-modal';

type TabKey = 'activos' | 'historial' | 'pases';

export function ConserjeDashboard() {
  const { condoId } = useCondoContext();
  const [tab, setTab] = useState<TabKey>('activos');
  const [walkInOpen, setWalkInOpen] = useState(false);

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Control de Visitas"
        title="Portería"
        subtitle="Ingresos activos, historial del condominio y pases QR pendientes."
        action={
          <Button onClick={() => setWalkInOpen(true)}>
            <Plus className="h-4 w-4" />
            Registrar walk-in
          </Button>
        }
      />

      <div className="flex gap-2 border-b border-[var(--color-hairline)] pb-2 mb-6">
        <TabButton active={tab === 'activos'} onClick={() => setTab('activos')}>
          Ingresos activos
        </TabButton>
        <TabButton active={tab === 'historial'} onClick={() => setTab('historial')}>
          Historial
        </TabButton>
        <TabButton active={tab === 'pases'} onClick={() => setTab('pases')}>
          Pases QR
        </TabButton>
      </div>

      {tab === 'activos' && <IngresosActivosTab condoId={condoId} />}
      {tab === 'historial' && <HistorialCondominioTab condoId={condoId} />}
      {tab === 'pases' && <VisitorPassesTab condoId={condoId} />}

      <WalkInModal
        condoId={condoId}
        open={walkInOpen}
        onClose={() => setWalkInOpen(false)}
      />
    </PageContainer>
  );
}

function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-2 text-sm transition-colors ${
        active
          ? 'text-[var(--color-ink)] border-b-2 border-[var(--color-accent)] -mb-[9px]'
          : 'text-[var(--color-ink-muted)] hover:text-[var(--color-ink)]'
      }`}
    >
      {children}
    </button>
  );
}
